import { render, staticRenderFns } from "./AdvertiserShow.vue?vue&type=template&id=5d5bcf2e&"
import script from "./AdvertiserShow.vue?vue&type=script&lang=js&"
export * from "./AdvertiserShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports